// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api';
import type {
  IChatsGetArchivedChatsDesktopRequest,
  TChatsGetArchivedChatsDesktopModel,
  IMappers,
  TChatsGetArchivedChatsDesktopResponse,
  IChatsGetArchivedChatsDesktopResponse,
  IChatsGetArchivedChatsDesktopResponseError,
} from './types';

export const defaultConfig: TChatsGetArchivedChatsDesktopModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  hostType: 'api',
  method: 'GET',
  microserviceName: 'chats',
  pathApi: '/v1/chats/get-archived-chats-desktop/',
} as TChatsGetArchivedChatsDesktopModel;

export function createChatsGetArchivedChatsDesktopModel(
  parameters: IChatsGetArchivedChatsDesktopRequest,
): TChatsGetArchivedChatsDesktopModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IChatsGetArchivedChatsDesktopOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: IChatsGetArchivedChatsDesktopRequest;
}

export async function fetchChatsGetArchivedChatsDesktop<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IChatsGetArchivedChatsDesktopOptions<TResponse200, TResponse400>): Promise<
  TChatsGetArchivedChatsDesktopResponse | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = await httpApi.fetch(
    createChatsGetArchivedChatsDesktopModel(parameters),
    config,
  );
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IChatsGetArchivedChatsDesktopResponse);
    }
    if (statusCode === 400) {
      return mappers[400](response as IChatsGetArchivedChatsDesktopResponseError);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as TChatsGetArchivedChatsDesktopResponse;
}
